<template>
    <div v-if="buckets.length > 0" class="card mb-3">
        <div class="card-header" v-show="showHeading">
            {{ translate('label.filters.category.' + filterName) }}
        </div>

        <div class="card-block">
            <div v-for="(filterData, index) in displayBuckets" class="card-text" :key="index"> 
                <div class="mt-1 mb-1">
                    <search-filter-link :referrer-url="referrerUrl"
                                        :filter-field-name="filterName"
                                        :filter-data="filterData"
                                        :is-checked="isAppliedFilter(filterData)"
                                        :translate-values="translateValues">
                    </search-filter-link>
                </div>
            </div>
            <a v-show="buckets > displayBuckets || (numberOfFilterValues && showAllFilterValues)" @click="showAllFilterValues = !showAllFilterValues" class="filter-show-more">{{ showAllFilterValues ? translate('label.filters.show_less') : translate('label.filters.show_more') }}</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            buckets: { type: Array, required: true },
            filterName: { type: String, required: true },
            selectedFilters: { type: Array, required: true },
            referrerUrl: { type: String, required: true },
            translateValues: { type: Boolean, required: false, default: false },
            showHeading: { type: Boolean, required: false, default: true },
            numberOfFilterValues: { type: Number, required: false }
        },

        data() {
            return {
                showAllFilterValues: this.numberOfFilterValues ? false : true
            }
        },

        methods: {
            isAppliedFilter(filterData) {
                for (var index = 0; index < this.selectedFilters.length; index++) {
                    // retain matching and empty (i.e. [not specified]) filter selections
                    if(this.selectedFilters[index] == null || filterData['key'] == this.selectedFilters[index]) {
                        return true;
                    }
                }
                return false;
            }
        },

        computed: {
            displayBuckets() {
                return !this.numberOfFilterValues || this.showAllFilterValues ? this.buckets : this.buckets.slice(0, this.numberOfFilterValues);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        background:transparent;
        border:0;
        .card-header { 
            color: #333;
            font-size: 0.875rem;
            border-bottom: 1px dotted #333;
            padding: 0 0 0.25rem 0;
            margin-bottom: 0.125rem;
            background:transparent;
        }
        label {
            color: #333;
        }
        a.filter-show-more {
            font-size: 0.875rem;
            cursor: pointer;
            color: #333;
        }
    }
</style>